import _ from 'lodash';
export default {
	hasChanged_({ selectedRow, oldSelectedRow, isOldRow }) {
		if (!isOldRow) return true;
		return !_.isEqual(selectedRow, oldSelectedRow);
	},
	powTourPrvsMngManagementCols_(state, getters, rootState, rootGetters) {
		//그리드 컬럼
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001137'), // 라인
				prop: 'powLnCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001137'), // 라인
				prop: 'powLnNm',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001030'), //공정
				prop: 'powPrvsCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001030'), //공정
				prop: 'powPrvsNm',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001301'), //검사내용
				minWidth: '150px',
				sortable: false,
				children: [
					{
						label: rootGetters['commonStore/getMessage_']('QWCC001213'), // 방식
						prop: 'insnWayCd',
						minWidth: '1px'
					},
					{
						label: rootGetters['commonStore/getMessage_']('QWCC001213'), // 방식
						prop: 'insnWayNm',
						minWidth: '200px'
					},
					{
						label: rootGetters['commonStore/getMessage_']('QWCC001215'), // 항목
						prop: 'insnPrvsSbc',
						minWidth: '300px'
					},
					{
						label: rootGetters['commonStore/getMessage_']('QWCC001216'), // 주기
						prop: 'insnCyclCd',
						minWidth: '1px'
					},
					{
						label: rootGetters['commonStore/getMessage_']('QWCC001216'), // 주기
						prop: 'insnCyclNm',
						minWidth: '200px'
					},
					{
						label: rootGetters['commonStore/getMessage_']('QWCC000920'), //시작일자
						prop: 'vbgStrtDd',
						minWidth: '1px'
					},
					{
						label: rootGetters['commonStore/getMessage_']('QWCC000920'), //시작일자
						prop: 'vbgStrtDdView',
						minWidth: '200px'
					}
				]
			},
			{
				label: rootGetters['commonStore/getMessage_']('MWCC000891'), // 사용여부
				prop: 'useYn',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('MWCC000891'), // 사용여부
				prop: 'useYnNm',
				minWidth: '100px'
			}
		];
	},
	powTourPrvsMngExcelCols_(state, getters, rootState, rootGetters) {
		//그리드 컬럼
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001137'), // 라인
				prop: 'powLnCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001137'), // 라인
				prop: 'powLnNm',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001030'), //공정
				prop: 'powPrvsCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001030'), //공정
				prop: 'powPrvsNm',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001213'), // 방식
				prop: 'insnWayCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001213'), // 방식
				prop: 'insnWayNm',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001215'), // 항목
				prop: 'insnPrvsSbc',
				minWidth: '300px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001216'), // 주기
				prop: 'insnCyclCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001216'), // 주기
				prop: 'insnCyclNm',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000920'), //시작일자
				prop: 'vbgStrtDd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000920'), //시작일자
				prop: 'vbgStrtDdView',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('MWCC000891'), // 사용여부
				prop: 'useYn',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('MWCC000891'), // 사용여부
				prop: 'useYnNm',
				minWidth: '100px'
			}
		];
	}
};
